export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "precache.worker.03761e0af51bc8c60ea4.worker.js");
}
